import { useFormik } from 'formik';
import { FC, useState } from 'react';
import { Enum } from '..';
import Checkbox from '../Checkbox';
import Input from '../Input';
import Label from '../Label';
import Select from '../Select';
import * as yup from 'yup';
import Upload from '../File';
import Alert from '../../layout/Alert';
import { uploadToS3 } from '../../core';

const countries = Array.from(
  new Set([
    'Select',
    'United States',
    'Canada',
    'France',
    'United Kingdom',
    'Afghanistan',
    'Åland Islands',
    'Albania',
    'Algeria',
    'American Samoa',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antarctica',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia, Plurinational State of',
    'Bonaire, Sint Eustatius and Saba',
    'Bosnia and Herzegovina',
    'Botswana',
    'Bouvet Island',
    'Brazil',
    'British Indian Ocean Territory',
    'Brunei Darussalam',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Cape Verde',
    'Cayman Islands',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Christmas Island',
    'Cocos (Keeling) Islands',
    'Colombia',
    'Comoros',
    'Congo',
    'Congo, the Democratic Republic of the',
    'Cook Islands',
    'Costa Rica',
    "Côte d'Ivoire",
    'Croatia',
    'Cuba',
    'Curaçao',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands (Malvinas)',
    'Faroe Islands',
    'Fiji',
    'Finland',
    'France',
    'French Guiana',
    'French Polynesia',
    'French Southern Territories',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada',
    'Guadeloupe',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Heard Island and McDonald Islands',
    'Holy See (Vatican City State)',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran, Islamic Republic of',
    'Iraq',
    'Ireland',
    'Isle of Man',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jersey',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    "Korea, Democratic People's Republic of",
    'Korea, Republic of',
    'Kuwait',
    'Kyrgyzstan',
    "Lao People's Democratic Republic",
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macao',
    'Macedonia, the former Yugoslav Republic of',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Martinique',
    'Mauritania',
    'Mauritius',
    'Mayotte',
    'Mexico',
    'Micronesia, Federated States of',
    'Moldova, Republic of',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Myanmar',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Niue',
    'Norfolk Island',
    'Northern Mariana Islands',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestinian Territory, Occupied',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Pitcairn',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Réunion',
    'Romania',
    'Russian Federation',
    'Rwanda',
    'Saint Barthélemy',
    'Saint Helena, Ascension and Tristan da Cunha',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Martin (French part)',
    'Saint Pierre and Miquelon',
    'Saint Vincent and the Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Sint Maarten (Dutch part)',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Georgia and the South Sandwich Islands',
    'South Sudan',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Svalbard and Jan Mayen',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syrian Arab Republic',
    'Taiwan, Province of China',
    'Tajikistan',
    'Tanzania, United Republic of',
    'Thailand',
    'Timor-Leste',
    'Togo',
    'Tokelau',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks and Caicos Islands',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'United States',
    'United States Minor Outlying Islands',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Venezuela, Bolivarian Republic of',
    'Viet Nam',
    'Virgin Islands, British',
    'Virgin Islands, U.S.',
    'Wallis and Futuna',
    'Western Sahara',
    'Yemen',
    'Zambia',
    'Zimbabwe',
  ]),
);

const Logo: FC = () => {
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const formik = useFormik({
    initialValues: {
      type: undefined,
      file: null,
      size: '',
      description: '',
      company: '',
      industry: '',
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      job: '',
      quantity: '1',
      country: '',
      source: '',
      urgent: false,
      agree: false,
    },
    validateOnMount: false,
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: yup.object({
      type: yup.string().oneOf(['BUSINESS', 'INDIVIDUAL']).required(),
      size: yup.string().required(),
      description: yup.string().required(),
      company: yup.string(),
      industry: yup.string(),
      firstname: yup.string().required(),
      lastname: yup.string().required(),
      email: yup.string().required(),
      phone: yup.string().required(),
      job: yup.string(),
      quantity: yup.string().required(),
      country: yup.string().required(),
      source: yup.string().required(),
      urgent: yup.boolean(),
      agree: yup.boolean().required().oneOf([true], 'Field must be checked'),
    }),
    onSubmit: () => {
      setIsSuccess(true);
      if (formik.values.file)
        uploadToS3(formik.values.file, 'logo').then((res) => {
          fetch(`https://xhquv4wyl7.execute-api.eu-central-1.amazonaws.com/dev/submissions`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...formik.values, banner: res }),
          });
          // TODO: add network layer
        });
      formik.resetForm();
    },
  });

  const _handleChange = (key: string) => (val: string | boolean) => formik.setFieldValue(key, val);
  const _handleDescriptionChange = ({ target: { value } }: any) => formik.setFieldValue('description', value);
  const _handleModalClose = () => setIsSuccess(false);
  const _handleSubmit = () => {
    formik.submitForm();
  };

  return (
    <>
      {isSuccess && (
        <Alert
          onClose={_handleModalClose}
          title='Thank you'
          subtitle={
            <>
              Thanks for submitting{' '}
              <strong>
                <span>design</span>
              </strong>
              ! We will get{' '}
              <strong>
                <span>back</span>
              </strong>{' '}
              to you soon.
            </>
          }
        />
      )}

      <hr />
      <h2>
        Promotions don't apply to custom logos. Please fill the form below to help us to create the neon of your dreams.
        We will get back to you as soon as possible. Please select:
      </h2>
      <Enum
        onChange={_handleChange('type')}
        value={formik.values.type}
        error={formik.errors.type}
        isSeparated
        options={[
          { label: 'I am an individual', value: 'INDIVIDUAL' },
          { label: 'We are a business', value: 'BUSINESS' },
        ]}
      />
      {formik.values.type && (
        <>
          <Label label='Please upload your design' required info='PNG or JPEG file only.'>
            <Upload label='Upload your design' onChange={_handleChange('file')} />
          </Label>
          <Label label='Please describe your project in a few words' required>
            <textarea
              onChange={_handleDescriptionChange}
              value={formik.values.description}
              name='description'
              placeholder='We need our logo 40 inches wide in white neon for the wall at the entrance of our office'
            />
          </Label>
          <Label label='What size are you looking for?' info='Input a rough width in cm' required>
            {/* <Select
              value={formik.values.size}
              error={formik.errors.size}
              onChange={_handleChange('size')}
              options={[
                { label: 'Minimum', value: 'MINIMUM' },
                { label: 'Small', value: 'SMALL' },
                { label: 'Medium', value: 'MEDIUM' },
                { label: 'Large', value: 'LARGE' },
                { label: 'Extra large', value: 'EXTRA-LARGE' },
              ]}
            /> */}
            <Input
              placeholder='25cm'
              value={formik.values.size}
              error={formik.errors.size}
              onChange={_handleChange('size')}
            />
          </Label>
          {formik.values.type === 'BUSINESS' && (
            <>
              <Label label='Company name' required>
                <Input
                  placeholder='Wayne corp'
                  value={formik.values.company}
                  error={formik.errors.company}
                  onChange={_handleChange('company')}
                />
              </Label>
              <Label label='Industry' required>
                <Select
                  value={formik.values.industry}
                  error={formik.errors.industry}
                  onChange={_handleChange('industry')}
                  options={[
                    { label: 'Select', value: '' },
                    { label: 'Beauty', value: 'beauty' },
                    { label: 'Corporate', value: 'corporate' },
                    { label: 'E-commerce', value: 'e-commerce' },
                    { label: 'Retailer', value: 'retailer' },
                    { label: 'Wholesaler', value: 'wholesaler' },
                    { label: 'Hospitality', value: 'hospitality' },
                    { label: 'Event planner', value: 'event_planner' },
                    { label: 'Interior designer', value: 'interior_designer' },
                    { label: 'Other', value: 'other' },
                  ]}
                />
              </Label>
            </>
          )}
          <Label label='First name' required>
            <Input
              placeholder='Bruce'
              value={formik.values.firstname}
              error={formik.errors.firstname}
              onChange={_handleChange('firstname')}
            />
          </Label>
          <Label label='Last name' required>
            <Input
              placeholder='Wayne'
              value={formik.values.lastname}
              error={formik.errors.lastname}
              onChange={_handleChange('lastname')}
            />
          </Label>
          <Label label='Email' info='Input an email address you want us to contact you width' required>
            <Input
              placeholder='bruce@wayne.corp'
              value={formik.values.email}
              error={formik.errors.email}
              onChange={_handleChange('email')}
            />
          </Label>
          <Label label='Phone' required>
            <Input
              placeholder='1234567890'
              value={formik.values.phone}
              error={formik.errors.phone}
              onChange={_handleChange('phone')}
            />
          </Label>
          {formik.values.type === 'BUSINESS' && (
            <>
              <Label label='Job title' required>
                <Select
                  value={formik.values.job}
                  error={formik.errors.job}
                  onChange={_handleChange('job')}
                  options={[
                    { label: 'CEO / Owner', value: 'CEO / Owner' },
                    { label: 'VP Marketing', value: 'VP Marketing' },
                    { label: 'Office Manager', value: 'Office Manager' },
                    { label: 'Director of Operation', value: 'Director of Operation' },
                    { label: 'Merchandise Manager', value: 'Merchandise Manager' },
                    { label: 'Interior Designer', value: 'Interior Designer' },
                    { label: 'Wedding Planner', value: 'Wedding Planner' },
                    { label: 'Architect', value: 'Architect' },
                    { label: 'Event Planner', value: 'Event Planner' },
                    { label: 'Other', value: 'Other' },
                    { label: 'Select', value: '' },
                  ]}
                />
              </Label>
            </>
          )}
          <Label label='Quantity needed' required info='How many signs do you want a quote for?'>
            <Select
              value={formik.values.quantity}
              error={formik.errors.quantity}
              onChange={_handleChange('quantity')}
              options={[
                { label: '1', value: '1' },
                { label: '2-5', value: '2-5' },
                { label: '5-10', value: '5-10' },
                { label: '10+', value: '10+' },
              ]}
            />
          </Label>
          <Label label='Country' required>
            <Select
              value={formik.values.country}
              error={formik.errors.country}
              onChange={_handleChange('country')}
              options={countries.map((country) => ({ label: country, value: country }))}
            />
          </Label>
          <Label label='How did you hear about us?' required>
            <Select
              value={formik.values.source}
              error={formik.errors.source}
              onChange={_handleChange('source')}
              options={[
                { label: 'Select', value: 'Select' },
                { label: "I'm already a customer", value: "I'm already a customer" },
                { label: 'Google', value: 'Google' },
                { label: 'Instagram / Facebook', value: 'Instagram / Facebook' },
                { label: 'Linkedin', value: 'Linkedin' },
                { label: 'Etsy', value: 'Etsy' },
                { label: 'Tiktok', value: 'Tiktok' },
                { label: 'Snapchat', value: 'Snapchat' },
                { label: 'Pinterest', value: 'Pinterest' },
                { label: 'Press', value: 'Press' },
                { label: 'Referral', value: 'Referral' },
                { label: 'Email', value: 'Email' },
                { label: 'Influencer', value: 'Influencer' },
                { label: 'OPUMO', value: 'OPUMO' },
              ]}
            />
          </Label>
          <Checkbox
            name='urgent'
            label='This project is urgent (in less than two weeks)'
            value={formik.values.urgent}
            error={formik.errors.urgent}
            onChange={_handleChange('urgent')}
          />
          <Checkbox
            name='agree'
            label='I agree with the Terms of Services and the Privacy Policy'
            value={formik.values.agree}
            error={formik.errors.agree}
            onChange={_handleChange('agree')}
          />
          <button onClick={_handleSubmit}>Submit</button>
        </>
      )}
    </>
  );
};

export default Logo;
